import { createSlice } from "@reduxjs/toolkit";

// Interface
import { IInitialState } from "./type";

const initialState: IInitialState = {
  data: {
    drugs: [],
    impurities: [],
  },
  loading: false,

  goTo: 1,
  currPage: 0,
  paged: true,
  pageSize: 4,

  relatedCompounds: [],
  relatedCompoundsLoading: false,
};

export const impuritiesForDrugSlice = createSlice({
  name: "impuritiesForDrug",
  initialState: initialState,
  reducers: {
    getRelatedCompounds: (state, action) => {
      state.relatedCompoundsLoading = true;
    },
    getRelatedCompoundsError: (state) => {
      state.relatedCompoundsLoading = false;
    },
    getRelatedCompoundsSuccess: (state, action) => {
      state.relatedCompoundsLoading = false;
      state.relatedCompounds = action.payload;
    },

    getProductInfoById: (state, action) => {
      state.loading = true;
    },
    getProductInfoByIdError: (state) => {
      state.loading = false;
    },
    getProductInfoByIdSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },

    handlerChangeCurrPage: (state, action) => {
      state.currPage = action.payload;
    },

    handlerChangeGoTo: (state, action) => {
      state.goTo = action.payload;
    },
  }
});

export const {
  getRelatedCompounds,
  getRelatedCompoundsSuccess,
  getRelatedCompoundsError,

  getProductInfoById,
  getProductInfoByIdError,
  getProductInfoByIdSuccess,

  handlerChangeGoTo,
  handlerChangeCurrPage,
} = impuritiesForDrugSlice.actions;

export default impuritiesForDrugSlice.reducer;
